// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ContestPosts__list":"so_a bhm_rc bhm_qx bhm_xr","ContestPosts__more":"so_b bhm_vu bhm_b bhm_va bhm_sv"};